"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketLocationOutput = {
    type: "structure",
    required: [],
    members: {
        LocationConstraint: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=GetBucketLocationOutput.js.map